import { getRadar, setRadarSlice } from './radar';

window.bouyguesScore = window.bouyguesScore || [];

/**
 * Get the score array
 *
 * @returns {Array} The score array
 */
function getScoreArray() {
	return window.bouyguesScore;
}

/**
 * Convert the given array to the same format as on the quiz page
 * @param {array} WPScoreArray the array spat out by wordpress's wp_localize_script
 * @returns {array}
 */
function convertWPScoreArray(WPScoreArray) {
	const scoreArray = [];
	WPScoreArray.forEach((answerObj) => {
		const { order } = answerObj;
		scoreArray[order] = answerObj;
	});

	return scoreArray;
}

/**
 * Add and answer to the global scoreArray
 *
 * @param {Array} scoreArray An array of the answers given so far
 * @param {Object} answerObj Object containing the answer details
 * @param {String} answerObj.answer    Numerical string the answer score
 * @param {String} answerObj.weighting Numerical string the weighting in the final score (float)
 * @param {String} answerObj.order     Numerical string the question number
 */
function addToScore(scoreArray, answerObj) {
	if (answerObj.answer === null) {
		answerObj.answer = 0;
	}
	const { order, answer } = answerObj;
	scoreArray[order] = answerObj;

	setRadarSlice(order, answer, getRadar());
}

/**
 * Total up the points, taking weighting into account
 *
 * @param {Array} scoreArray The array of scores
 * @returns {Number}
 */
function getScore(scoreArray) {
	const reducer = (previous, current) => {
		const answer = parseFloat(current.answer);
		const weighting = parseFloat(current.weighting);
		const increment = answer * weighting;

		// round to 2 dp - this is because floating point maths
		// ended up giving us e.g. 7.00000000001.
		return Math.round(100 * (previous + increment)) / 100;
	};

	const score = scoreArray.reduce(reducer, 0);
	return 10 * score;
}

export { getScoreArray, getScore, addToScore, convertWPScoreArray };
